import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TenantPage from 'layouts/TenantPage';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import toast from 'shared/utils/toast';
import { ticketingService } from '../TicketingService';
import { useTicketColumns } from '../tickets';

export const ArchivedTickets = () => {
  const translationPrefix = 'pages.archived-tickets';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const handleDelete = (id: number) => {
    ticketingService.delete(id).then(() => {
      toast.success(t('actions.successfully.deleted'));
      datagridRefresh.current();
    });
  };

  const columns = useTicketColumns({ handleDelete });

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}>
        <EnhancedDataGrid
          columns={columns}
          service={ticketingService}
          getMethod={ticketingService.getClosed}
          refresh={datagridRefresh}
          disableDelete
        />
      </TenantPage>
    </>
  );
};

export default ArchivedTickets;
